import styled from "styled-components";
import DoubleArrowIcon from "@material-ui/icons/DoubleArrow";
import DownArrow from "web/assets/images/arrow_bottom_down_downward_navigation_icon.png";

const MenuIcon = styled(DoubleArrowIcon)`
  position: absolute;
  left: 22px;
  color: #0cadef;
  font-size: 40px !important;
  top: 16px;
  cursor: pointer;
`;
export const RightSection = styled.div`
  display: flex;
  align-items: baseline;
  gap: 30px;
  padding-bottom: 25px;
  flex-wrap: wrap;

  justify-content: flex-end;
`;

export const SearchWrapper = styled.div`
  display: flex;
  position: relative;
  overflow: auto;

  width: 286px;
  height: 44px;
  input {
    background: #ffffff;
    border-radius: 6px;
    border: solid 1px #dadadf;
    padding: 4px 15px 4px 45px;
    width: 100%;
    font-size: 14px;
    font-family: "latoregular";

    ::-webkit-input-placeholder {
      /* Edge */
      color: #a0a7b8;
      font-family: "latoregular";
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #a0a7b8;
      font-family: "latoregular";
    }

    ::placeholder {
      color: #a0a7b8;
      font-family: "latoregular";
    }
  }
  .search-icon {
    position: absolute;
    transform: translate(18px, 16px);
  }
`;

const Wrapper = styled.div`
  align-items: stretch;
  display: flex;
  width: 100%;
  .sideBarNonActive {
    margin-left: 60px;
  }
  .webView {
    display: block;
  }

  .mobileView {
    display: none;
  }
  @media (max-width: 1024px) {
    .sideBarActive {
      .ham {
        display: none;
      }
    }
    .sideBarNonActive {
      margin-left: 0;
      z-index: 1;
    }
    .webView {
      display: none;
    }
    .mobileView {
      display: block;
    }
  }
`;
const Sidebar = styled.div`
  min-width: 238px;
  max-width: 238px;
  transition: margin-left 0.35s ease-in-out, left 0.35s ease-in-out,
    margin-right 0.35s ease-in-out, right 0.35s ease-in-out;
  direction: ltr;
  background: #0a1f30;
  color: white;
  position: absolute;
  bottom: 0;
  top: 0;
  h5 {
    font-size: 14px;
    padding: 14px 14px 14px 20px;
  }
  .ptplus-user-manage {
    margin-left: 60px;
  }
  i {
    border: solid #fff;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    margin: 2px 2px 2px 46px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }
  a {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 14px 14px 14px 20px;
    img {
      margin-right: 20px;
    }
  }
  a.active {
    background-color: rgba(255, 255, 255, 0.1);
    color: white;
    position: relative;
    ::before {
      content: "";
      display: block;
      border-radius: 3.2px;
      background-color: #00adef;
      width: 6px;
      height: 80%;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  }
  .leftLogo {
    margin-left: 0;
  }

  .navListStyle {
    height: 87%;
    overflow: auto;
  }
  .navListStyle::-webkit-scrollbar {
    width: 8px;
  }
  .navListStyle::-webkit-scrollbar-track {
    background: #d4e2e9;
    border-radius: 5px;
    border: 1px solid #005586;
  }
  .navListStyle::-webkit-scrollbar-thumb {
    background: #005586;
    border-radius: 5px;
    border: 1px solid #005586;
  }
  .side_bar::-webkit-scrollbar-thumb:hover {
    background: #009eb3;
  }

  .webView {
    display: block;
  }

  .mobileView {
    display: none;
  }

  @media (max-width: 1024px) {
    z-index: 1;

    .webView {
      display: none;
    }

    .mobileView {
      display: block;
    }
  }
`;
const MainSection = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  min-width: 0;
  transition: margin-left 0.35s ease-in-out, left 0.35s ease-in-out,
    margin-right 0.35s ease-in-out, right 0.35s ease-in-out;
  flex-direction: column;
  margin-left: 238px;
  position: relative;
  @media (max-width: 1024px) {
    margin-left: 0;
  }
`;
const Header = styled.div`
  background-color: #ededed;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  .ham {
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transition: transform 400ms;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    position: absolute;
    left: 22px;
    background: #0a1f30;
    border-radius: 50%;
  }

  .line {
    fill: none;
    transition: stroke-dasharray 400ms, stroke-dashoffset 400ms;
    stroke: #0cadef;
    stroke-width: 5.5;
    stroke-linecap: round;
  }

  .ham2 .top {
    stroke-dasharray: 40 121;
  }
  .ham2 .bottom {
    stroke-dasharray: 40 121;
  }
  .ham2.active .top {
    stroke-dashoffset: -102px;
  }
  .ham2.active .bottom {
    stroke-dashoffset: -102px;
  }
  > img {
    padding: 0 26px;
  }
  > div {
    display: flex;
    align-items: center;
    padding: 0 26px;
    border-left: solid 1px #d1d1d1;
  }
`;
const Body = styled.div`
  height: calc(100vh - 48px);
  background-color: #f9f9f9;
  padding: 12px 27px;
  overflow: auto;
  @media (max-width: 650px) {
    padding: 15px;
  }
`;

const HeaderLogo = styled.div`
  padding: 25px 11px;
  max-width: 62px;
  margin: 0 auto;
  position: relative;
  transition: margin-left 0.35s ease-in-out, left 0.35s ease-in-out,
    margin 0.35s ease-in-out, right 0.35s ease-in-out;
  .openMenuIcon {
    position: absolute;
    right: -17px;
    top: 21px;
    display: none;
    .ham {
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      transition: transform 400ms;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      position: absolute;
      left: 22px;
      background: #87cdf1;
      border-radius: 50%;
    }

    .line {
      fill: none;
      transition: stroke-dasharray 400ms, stroke-dashoffset 400ms;
      stroke: #0a1f30;
      stroke-width: 5.5;
      stroke-linecap: round;
    }

    .ham2 .top {
      stroke-dasharray: 40 121;
    }
    .ham2 .bottom {
      stroke-dasharray: 40 121;
    }
    .ham2.active .top {
      stroke-dashoffset: -102px;
    }
    .ham2.active .bottom {
      stroke-dashoffset: -102px;
    }
  }
  img {
    width: 100%;
  }
  @media (max-width: 1024px) {
    .openMenuIcon {
      display: block;
    }
  }
`;
const UserImage = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  > img {
    width: 100%;
  }
`;
const UserName = styled.div`
  padding: 0 14px;
  > h3 {
    color: #232323;
    font-size: 16px;
  }
  p {
    color: #646464;
    font-size: 10.5px;
    margin: 0;
  }
`;
const Heading = styled.div`
  display: flex;
  align-items: center;
  background-color: #87cdf1;
  padding: 11px 16px;
  min-height: 66px;
  flex-wrap: wrap;
  gap: 10px;
  border-radius: 15px 15px 0 0;
  h3 {
    font-size: 18px;
    color: #000;
    font-family: "latosemibold";
    flex-grow: 1;
  }
  .vertical-line {
    border: 1px solid #cbedff;
    margin: 1px 5px 2px 9px;
  }
  .button-style-green {
    background: rgb(39, 145, 27);
    color: white;
    border: 0px;
    border-radius: 5px;
    padding: 5px 15px;
    margin: 5px;
  }
  .disabled-button {
    cursor: default;
    opacity: 0.5;
  }
  .promo-heading-select-style {
    background-image: url(${DownArrow});
    background-repeat: no-repeat;
    background-position: calc(100% - 10px) 50%;
    border: solid 1px #dadadf !important;
    margin: 2px 0;
    font-size: 16px;
    padding: 0px 0px 2px 14px;
    border-radius: 5px;
    appearance: none;
    min-width: 250px;
    height: 33px;
    margin-left: 15px;
    cursor: pointer;
  }
  .promo-head-section{
    display: flex;
    flex-grow: 1;
    > h3{
      flex-grow: 0;
      display: flex; 
      slign-items: center;
    }
  }
  .promo-code-user-list-header{
    display: flex;
    flex-direction: column;
    width: 100%;
    .section-one, .section-two{
      display: flex;
      justify-content: space-between;
      .info-section, .action-section{
        display: flex;
      }
      .info-section h3:last-child{
        margin-left: 25px;
      }
      .action-section .promo-actions{
        margin-left: 20px;
      }
    }
  }
  .search-input-wrap{
    max-width: 250px;
  }
  @media (max-width: 465px){
    gap: 0;
    .promo-head-section{
      display: block;
      width: 100%;
      > h3{
        display: block;
        width: 100%;
      }
      select{
        margin: 10px 0 0 0;
        width: 100%;
      }
    }
    > div{
      display: block;
      width: 100%;
    }
    .section-one, .section-two, .info-section, .action-section, .promocode-checkout-search-wrapper{
      display: block !important;
      width: 100%;
      .search-input-wrap{
        max-width: 100%;
      }
    }
    .info-section h3:last-child{
      margin-left: 0 !important;
      margin-top:10px;
      margin-bottom:10px;
    }
    .action-section .promo-actions{
      margin-left: 0 !important;
    }
    .promo-actions input{
      width: 100% !important;
    }
  }
`;
const TableWrapper = styled.div`
  border-radius: 15px;
  border: solid 1px #87cdf1;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 9px 8px 0 rgb(0 0 0 / 16%);
  .post-tab-table-tbody {
    .order-details-wrapper {
      background-color: #f2f2f2;
      border-left: 1px solid;
      border-right: 1px solid;

      td {
        padding: 0.5rem 0.75rem;
        border: none;
        p {
          margin: 4px 0;
        }
      }
    }
  }
  .table thead th {
    vertical-align: top;
    white-space: nowrap;
  }
  .table thead th,
  .table td,
  .table th {
    font-size: 14px;
  }
  .MuiPagination-ul {
    padding: 15px;
  }
  .MuiTab-textColorInherit.Mui-selected {
    opacity: 1;
    color: #0a1f30;
    font-family: "latobold" !important;
  }
  .MuiBox-root {
    padding: 0;
  }
  .MuiTab-root {
    opacity: 1;
    text-transform: capitalize;
    font-family: "latomedium";
    padding: 15px !important;
  }
  .MuiAppBar-colorPrimary {
    color: #7a7a7a;
    background-color: transparent;
    box-shadow: none;
    text-transform: capitalize;
  }
  .MuiTabs-indicator {
    border: solid 2px #2fb5f1;
    /* color: #0a1f30; */
  }
  .toggle-button-style {
    .MuiSwitch-root {
      width: 50px;
      height: 34px;
    }
    .MuiSwitch-thumb {
      width: 15px;
      height: 15px;
    }
  }
  .user-list-table-styles {
    svg {
      margin: 0 8px 0 4px;
      cursor: pointer;
    }
  }
  .action-popups {
    display: grid;
    width: 156px;
    border: 1px solid #dadada;
    border-radius: 10px;
    padding: 5px 25px 5px 25px;
    position: absolute;
    top: 52px;
    right: 10px;
    background: #fff;
    z-index: 1;
    div {
      display: flex;
      cursor: pointer;
    }
    span {
      margin: 10px;
    }
    .top-arrow {
      position: absolute;
      width: 15px;
      height: 15px;
      background: #ffff;
      border: solid #dadada;
      border-width: 1px 0 0 1px;
      transform: rotate(45deg);
      top: -16px;
      right: 16px;
    }
  }
  .action-popups-align-top {
    display: grid;
    width: 156px;
    border: 1px solid #dadada;
    border-radius: 10px;
    padding: 5px 25px 5px 25px;
    position: absolute;
    bottom: 50px;
    right: 10px;
    background: #fff;
    z-index: 1;
    div {
      display: flex;
      cursor: pointer;
    }
    span {
      margin: 10px;
    }
    .top-arrow {
      position: absolute;
      width: 15px;
      height: 15px;
      background: #ffff;
      border: solid #dadada;
      border-width: 1px 0 0 1px;
      transform: rotate(225deg);
      bottom: -16px;
      right: 16px;
    }
  }

  .expand-collapse-class {
    display: flex;
    h4 {
      background: #005586;
      padding: 0px;
      width: 17px;
      border-radius: 50%;
      height: 16px;
      margin: 3px 0px 0px 11px;
      cursor: pointer;
      i {
        border: solid #ffff;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 2px;
        margin: 0px 0px 13px 6px;
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
      }
    }
    h5 {
      background: #005586;
      padding: 0px;
      width: 16px;
      border-radius: 50%;
      height: 16px;
      margin: 3px 0px 0px 11px;
      cursor: pointer;
      i {
        border: solid #ffff;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 2px;
        margin: 0px 0px 13px 5px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }
    }
  }
  .expand-collapse-class-inside {
    display: flex;
    h4 {
      /* background: #005586; */
      padding: 0px;
      width: 17px;
      border-radius: 50%;
      height: 16px;
      margin: 3px 0px 0px 11px;
      cursor: pointer;
      i {
        border: solid #000;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 2px;
        margin: 0px 0px 13px 6px;
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
      }
    }
    h5 {
      /* background: #005586; */
      padding: 0px;
      width: 16px;
      border-radius: 50%;
      height: 16px;
      margin: 3px 0px 0px 11px;
      cursor: pointer;
      i {
        border: solid #000;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 2px;
        margin: 0px 0px 13px 5px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }
    }
  }
`;

const SubHeading = styled.div`
  padding: 15px;
  h4 {
    font-size: 20px;
    color: #02a7f1;
    font-family: "latomedium";
  }
`;
const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export {
  ButtonWrapper,
  Wrapper,
  Sidebar,
  MainSection,
  Header,
  Body,
  HeaderLogo,
  SubHeading,
  UserImage,
  UserName,
  MenuIcon,
  Heading,
  TableWrapper,
};
